import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { BehaviorSubject } from 'rxjs';
import { environment } from '~environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly uploadEndpoint = `${environment.apiTriidyUrlRest}/api/S3Base64Carga`;

  // RESPONSE
  private elementSource = new BehaviorSubject<string>('');
  element = this.elementSource.asObservable();
  FOLDER = 'mensajeros/';

  constructor(private http: HttpClient, private authService: AuthService) { }

  /*postFile(fileToUpload: File): Observable<any> {
    const endpoint = 'https://api.imgbb.com/1/upload?key=5369e11aca31e8004f3a7a3172b96fab';
    const formData: FormData = new FormData();
    console.log(fileToUpload.name);

    formData.append('image', fileToUpload, fileToUpload.name);
    return this.http.post<any>(endpoint, formData).pipe(
      map(res => {
        console.log(res);
      }));
  }*/

  uploadfile(file) {

    const contentType = file.type;

    const bucket = new S3(
      {
        accessKeyId: environment.accessKeyId,
        secretAccessKey: environment.secretAccessKey,
        region: 'us-east-2'
      }
    );

    const params = {
      Bucket: 'triidyftp',
      ACL: 'public-read',
      ContentType: contentType,
      headers: {
        'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'OPTIONS,POST,GET',
        'Access-Control-Allow-Credentials': true
      },
      Key: this.FOLDER + file.name,
      Body: file,
    };

    bucket.upload(params, function (err, data) {
      if (err) {
        //console.log('There was an error uploading your file: ', err);
        return false;
      }

      //console.log('Successfully uploaded file.', data);
      return true;
    });
  }
  /**
 * Sube un archivo utilizando el nuevo servicio backend.
 */
  uploadFile(file: any, keyName: string, ruta: string): Promise<any> {
    const key = atob(this.authService.leerToken());
    const id_tienda = atob(this.authService.leerIdTienda());
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result?.toString().split(',')[1]; // Extraer solo el contenido base64
        if (!base64) {
          reject('Error al convertir el archivo a base64');
          return;
        }

        const body = {
          key: key ? key : environment.keyLoginGeneral, // O ajustar según se requiera
          id_tienda_login: id_tienda ? id_tienda : environment.id_tienda_login, // Ajusta este valor con el correspondiente
          bucketName: "triidyftp/" + ruta,
          keyName,
          fileBase64: base64,
        };

        // Llamar al servicio backend
        this.http.post(this.uploadEndpoint, body).subscribe(
          (response) => {
            this.respService('success', 'Archivo subido con éxito');
            resolve(response);
          },
          (error) => {
            this.respService('error', 'Error al subir el archivo');
            reject(error);
          }
        );
      };

      reader.onerror = (error) => reject(error);

      // Convertir el archivo a base64
      reader.readAsDataURL(file);
    });
  }

  respService(msg: any, type: any) {
    this.elementSource.next(`${msg}.${type}`);
  }
}
